import React, {useState} from "react";
import {Checkbox, CircularProgress, FormControlLabel, IconButton, TextField} from "@mui/material";
import {Delete as DeleteIcon, Edit as EditIcon} from "@mui/icons-material";
import {SelectField} from "@atttomyx/react-components";
import {RankField} from "../fields";
import {courseService} from "../../services";
import {cloudinary, forms, objects, strings} from "@atttomyx/shared-utils";
import {sortingUtils} from "../../utils";
import {PLACEHOLDER_LANDSCAPE, STATUSES} from "../../constants";
import "./courseForm.css";

const CourseForm = (props) => {
    const {snackbar, courseId, data, onChange: onSync} = props;
    const [uploading, setUploading] = useState(false);

    const onChange = (field, value) => {
        const modified = objects.deepCopy(data);

        modified[field] = value;
        modified.valid = strings.isNotBlank(modified.name)
            && modified.ranks && modified.ranks.length > 0
            && strings.isNotBlank(modified.status)
            && sortingUtils.isSortable(modified.order);

        onSync(modified);
    };

    const uploadImage = (event) => {
        const file = event.target.files[0];

        setUploading(true);

        const success = (imageUrl) => {
            setUploading(false);
            onChange("imageUrl", imageUrl);
        };

        const failure = (err) => {
            setUploading(false);
            snackbar.setError(err);
        };

        courseService.uploadImage(courseId, file, success, failure);
    };

    const removeImage = () => {
        onChange("imageUrl", null);
    };

    return <div className="course-form">
        {courseId ?
            <div>
                {uploading ? <CircularProgress size="40px"/> :
                    <>
                        <img
                            className="course"
                            alt={data.title}
                            src={data.imageUrl ? cloudinary.trim(data.imageUrl) : PLACEHOLDER_LANDSCAPE}
                        />
                        <div>
                            <IconButton
                                color="secondary" title="Delete image"
                                disabled={!data.imageUrl}
                                onClick={removeImage}
                            >
                                <DeleteIcon/>
                            </IconButton>
                            <input
                                hidden
                                accept="image/*"
                                id="course-file"
                                type="file"
                                onChange={uploadImage}
                            />
                            <label htmlFor="course-file">
                                <IconButton color="primary" title="Upload image" component="span">
                                    <EditIcon/>
                                </IconButton>
                            </label>
                        </div>
                    </>}
            </div> : null}
        <div className="field top-margin">
            <TextField
                required={true}
                label="Name"
                type="text"
                value={forms.sanitizeValue(data.name)}
                onChange={(event) => onChange("name", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                multiline={true}
                minRows={2}
                label="Description"
                type="text"
                value={forms.sanitizeValue(data.description)}
                onChange={(event) => onChange("description", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="URL"
                type="url"
                value={forms.sanitizeValue(data.gotoUrl)}
                onChange={(event) => onChange("gotoUrl", event.target.value)}
            />
        </div>
        <div className="field">
            <TextField
                label="URL Label"
                type="text"
                value={forms.sanitizeValue(data.gotoLabel)}
                onChange={(event) => onChange("gotoLabel", event.target.value)}
            />
        </div>
        <div className="field">
            <RankField
                value={forms.sanitizeValue(data.ranks)}
                onChange={(value) => onChange("ranks", value)}
            />
        </div>
        <div className="field">
            <SelectField
                required={true}
                label="Status"
                value={forms.sanitizeValue(data.status)}
                onChange={(value) => onChange("status", value)}
                options={STATUSES}
            />
        </div>
        <div className="field">
            <TextField
                required={true}
                label="Index"
                type="number"
                value={forms.sanitizeValue(data.order)}
                onChange={(event) => onChange("order", event.target.value)}
                inputProps={{
                    step: 1,
                    min: 0,
                }}
            />
        </div>
        <div className="option">
            <FormControlLabel
                label="Music?"
                control={<Checkbox
                    color="primary"
                    checked={forms.sanitizeOption(data.music)}
                    onChange={(event) => onChange("music", event.target.checked)}
                />}
            />
        </div>
    </div>
}

export default CourseForm;
